import apiOffer from './interceptorOffer'

// 获取卡券状态: 是否是临期卡券
export const getCouponReminderStatusApi = params => {
  return apiOffer.post('/admin/api/v1/offer/offer-coupon-reminder', params )
}